import React from 'react';
import { Box, Typography } from '@mui/material';

export default function ConfigPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Configurações
      </Typography>
      <Typography color="textSecondary">
        Página de configurações em construção
      </Typography>
    </Box>
  );
}